export class MetricEdit
{
    public id = null;
    public version = null;
    public name = '';
    public description = '';
    public denominator = null;
    public denominatorDescription = '';
    public numerator = null;
    public numeratorDescription = '';
    public active = true;
    public metricType = null;
    public metricRateMode = null;
}
